import PrivateRoutes from '../../../../routes/PrivateRoutes';
import AutoLogout from '../../../../components/auto-logout/AutoLogout';

// ------- FOR AUTHENTICATED FLOW --------
// Home for private routes. Any private route will go through this.
// Anything that needs to be done specifically for private routes can be done here.
const Home = (): JSX.Element => {
  return (
    <AutoLogout>
      <PrivateRoutes />
    </AutoLogout>
  );
};

export default Home;
